'use es6';

import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import Toggle from '../Toggle';
import MarketableContactsWarningModal from './MarketableContactsWarningModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.${key}`;
const KB_ARTICLE_URL = 'https://knowledge.hubspot.com/contacts/marketing-contacts';
const labelHelp = /*#__PURE__*/_jsx(FormattedJSXMessage, {
  message: i18nKey('withInlineEditing.automation.marketingContacts.help_jsx'),
  elements: {
    Link: UILink
  },
  options: {
    href: KB_ARTICLE_URL
  }
});
const label = /*#__PURE__*/_jsxs("span", {
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey('withInlineEditing.automation.marketingContacts.label')
  }), ' ', "\xA0", /*#__PURE__*/_jsx(UIHelpIcon, {
    title: labelHelp,
    tooltipPlacement: "right"
  })]
});
const MarketingContactsToggle = ({
  disabledTooltipTitle,
  formName = '',
  value,
  hasPermissions,
  hasFormsWriteAccess,
  onChange,
  readOnly = false
}) => {
  const [showDisableConfirmModal, setShowDisableConfirmModal] = useState(false);
  const handleChange = () => {
    const newValue = !value;
    if (newValue === false) {
      setShowDisableConfirmModal(true);
    } else {
      onChange(!value);
    }
  };
  const handleDisableConfirm = () => {
    const newValue = !value;
    onChange(newValue);
    setShowDisableConfirmModal(false);
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Toggle, {
      id: "marketing-contacts-toggle",
      label: label,
      disabledTooltipTitle: disabledTooltipTitle,
      value: value,
      disabled: !hasFormsWriteAccess || !hasPermissions || readOnly,
      onChange: handleChange
    }), showDisableConfirmModal && /*#__PURE__*/_jsx(MarketableContactsWarningModal, {
      formName: formName,
      onConfirm: handleDisableConfirm,
      onCancel: () => setShowDisableConfirmModal(false)
    })]
  });
};
export default MarketingContactsToggle;